import type { IconSvgObject } from './types';

const SaveEnergy02Icon: IconSvgObject = [
  ["path", { d: "M12 3.5V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 3.5C17.5228 3.5 22 7.3635 22 13.5H2C2 7.3635 6.47715 3.5 12 3.5Z", stroke: "currentColor", strokeLinecap: "square", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 3.5C14.4853 3.5 16.5 7.3635 16.5 13.5H7.5C7.5 7.3635 9.51472 3.5 12 3.5Z", stroke: "currentColor", strokeLinecap: "square", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 13.5V20.6579C12 21.3991 11.3284 22 10.5 22C9.67157 22 9 21.3991 9 20.6579V20.2105", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M18.5 16L16 19H20L17.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default SaveEnergy02Icon;
